export class Dictionary {
    items: {[key: string]: any};
    constructor() {
      this.items = {};
    }
    public has(key: string) {
      return key in this.items;
    }
    public set(key: string, value: any) {
      this.items[key] = value;
    }
    public get(key: string) {
      return this.items[key];
    }
    public delete(key: string) {
      if( this.has(key) ){
        delete this.items[key];
        return true;
      }
      return false;
    }   
    public toJson() {
        return JSON.stringify(this.items);
    } 
}
